(() => {
  const root = document.querySelector('[data-wave-story]');
  if (!root) return;
  // Use the same discount resolver and market formatter as the PDP. Liquid remains
  // authoritative if the pricing runtime is unavailable.
  const price = root.querySelector('[data-story-price]');
  const variantIds = new Set((root.dataset.variantIds || '').split(','));
  let activeVariant = { price: price?.dataset.initialPrice, compare_at_price: price?.dataset.initialComparePrice };
  const updatePrice = () => {
    const pricing = window.SBStorefrontPricing;
    if (!price || !pricing?.resolvePrice || !pricing?.formatMoney) return;
    const resolved = price.dataset.hideDiscounts === 'true'
      ? { currentPriceCents: Number(activeVariant.price), comparePriceCents: null }
      : pricing.resolvePrice({ productId: root.dataset.productId, priceCents: Number(activeVariant.price), comparePriceCents: Number(activeVariant.compare_at_price) });
    if (!resolved || !Number.isFinite(resolved.currentPriceCents)) return;
    const format = amount => pricing.formatMoney(amount, price.dataset.currency, { context: 'storefront' });
    price.querySelector('[data-story-current]').textContent = format(resolved.currentPriceCents);
    const compare = price.querySelector('[data-story-compare]');
    compare.hidden = !(resolved.comparePriceCents > resolved.currentPriceCents);
    price.querySelector('[data-story-compare-value]').textContent = compare.hidden ? '' : format(resolved.comparePriceCents);
    const savings = price.querySelector('[data-story-savings]');
    savings.hidden = compare.hidden;
    const savingsPercent = compare.hidden ? 0 : Math.round((resolved.comparePriceCents - resolved.currentPriceCents) * 100 / resolved.comparePriceCents);
    savings.textContent = compare.hidden ? '' : price.dataset.savingsTemplate.replace('__PERCENT__', String(savingsPercent));
  };
  updatePrice();
  document.addEventListener('sb:storefront-pricing:changed', updatePrice);
  document.addEventListener('variant:update', event => {
    const variant = event.detail?.resource;
    if (!variant || !variantIds.has(String(variant.id))) return;
    const sourceProduct = event.target.closest?.('.sb-product-main')?.dataset.productId;
    if (sourceProduct && sourceProduct !== root.dataset.productId) return;
    if (variant.price == null || variant.price === '' || !Number.isFinite(Number(variant.price))) return;
    activeVariant = variant;
    updatePrice();
  });
  const main = root.closest('main');
  const section = root.closest('.shopify-section');
  const progress = [...root.querySelectorAll('[data-story-progress]')];
  const chapters = progress.map(link => document.querySelector(link.getAttribute('href'))).filter(Boolean);
  if (!main || !section || !chapters.length) return;
  const lastIndex = chapters.length - 1;
  let current = 0;
  let touch = null;
  const choose = (explorer, selected) => {
    if (!selected) return;
    const chapter = explorer.closest('[data-story-chapter]');
    chapter.dataset.storySelection = selected.dataset.storyChoice;
    explorer.querySelectorAll('[data-story-choice]').forEach(button => {
      button.setAttribute('aria-pressed', String(button === selected));
    });
    explorer.querySelectorAll('[data-story-choice-panel]').forEach(panel => {
      panel.hidden = panel.dataset.storyChoicePanel !== selected.dataset.storyChoice;
    });
    chapter.querySelectorAll('[data-story-visual]').forEach(visual => {
      visual.hidden = visual.dataset.storyVisual !== selected.dataset.storyChoice;
    });
    const driverCount = chapter.querySelector('[data-story-driver-count]');
    if (driverCount) driverCount.textContent = selected.dataset.storyChoice === 'system' ? driverCount.dataset.total : driverCount.dataset.pair;
  };
  root.querySelectorAll('[data-story-explorer]').forEach(explorer => {
    choose(explorer, explorer.querySelector('[data-story-choice]'));
    explorer.classList.add('is-ready');
  });
  root.addEventListener('click', event => {
    const choice = event.target.closest('[data-story-choice]');
    if (choice) choose(choice.closest('[data-story-explorer]'), choice);
    if (event.target.closest('[data-story-shortcut]')) root.dispatchEvent(new CustomEvent('wave-story:shortcut'));
  });
  document.body.classList.add('sb-story-player');

  const show = (index, { focus = false, historyMode = '', target = null } = {}) => {
    current = Math.max(0, Math.min(index, lastIndex));
    chapters.forEach((chapter, i) => {
      chapter.hidden = i !== current;
      chapter.inert = i !== current;
    });
    progress.forEach((link, i) => {
      link.classList.toggle('is-complete', i < current);
      if (i === current) link.setAttribute('aria-current', 'step');
      else link.removeAttribute('aria-current');
    });
    main.scrollTop = 0;
    window.SBSectionMotion?.resetScope(chapters[current]);
    if (historyMode) {
      const url = new URL(location.href);
      url.hash = target?.id || chapters[current].id;
      history[historyMode === 'push' ? 'pushState' : 'replaceState'](history.state, '', url);
    }
    if (focus) (target || chapters[current]).querySelector('h1, h2')?.focus({ preventScroll: true });
    root.dispatchEvent(new CustomEvent('wave-story:chapter', { detail: { chapter: chapters[current].id } }));
  };
  const fromHash = () => {
    const target = document.getElementById(location.hash.slice(1));
    const index = chapters.indexOf(target);
    show(index >= 0 ? index : 0, { target });
  };
  const go = (index) => { if (index >= 0 && index <= lastIndex) show(index, { focus: true, historyMode: 'push' }); };
  document.addEventListener('click', event => {
    const link = event.target.closest('.sb-wave-story a[href^="#"]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    const index = chapters.indexOf(target);
    if (index < 0) return;
    event.preventDefault();
    show(index, { focus: true, historyMode: 'push', target });
  });
  root.addEventListener('keydown', event => {
    if (event.target.matches('.sb-wave-story__copy')) return;
    if (event.target.closest('input, select, textarea, details, button') || event.metaKey || event.ctrlKey || event.altKey) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); go(current + 1); }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); go(current - 1); }
  });
  root.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'touch' || !event.target.closest('.sb-wave-story__media') || event.target.closest('button, a, input, select, textarea, details')) return;
    touch = { id: event.pointerId, x: event.clientX, y: event.clientY };
    event.target.setPointerCapture(event.pointerId);
  });
  root.addEventListener('pointercancel', () => { touch = null; });
  root.addEventListener('pointerup', event => {
    if (!touch || touch.id !== event.pointerId) return;
    const dx = event.clientX - touch.x;
    const dy = event.clientY - touch.y;
    touch = null;
    const delta = Math.abs(dx) > Math.abs(dy) ? dx : dy;
    if (Math.abs(delta) >= 50) go(current + (delta < 0 ? 1 : -1));
  });
  addEventListener('popstate', fromHash);
  addEventListener('hashchange', fromHash);
  document.addEventListener('shopify:block:select', event => {
    const chapter = event.target.closest('[data-story-chapter]');
    const index = chapters.indexOf(chapter);
    if (index >= 0) show(index);
  });
  const resizeHeader = () => document.body.style.setProperty('--story-top', `${Math.ceil(root.querySelector('header').getBoundingClientRect().height)}px`);
  new ResizeObserver(resizeHeader).observe(root.querySelector('header'));
  resizeHeader();
  fromHash();
})();
